export const getCurrentTask = (state, id) => {
  const pane = state.activedFlows.pane;

  if (pane.status !== 'succeeded') {
    return false;
  }
  return pane.flow.elements.find((item) => item.id === id);
};

export const getTask = (state, id) =>
  state.activedTasks.pagination.find((task) => task._id === id);
